<template>
    <div>
        <div class="news-banner">
            <img src="../../../assets/images/banner7.png" alt="">
        </div>
        <!-- 面包屑 -->
        <Breadcrumb separator=">" class="nav_rot">
            <Breadcrumb-item><router-link to="/">首页</router-link></Breadcrumb-item>
            <Breadcrumb-item><router-link to="/news">新闻中心</router-link></Breadcrumb-item>
            <Breadcrumb-item>公司动态</Breadcrumb-item>
        </Breadcrumb>

        <!-- 公司动态第一张内容 -->
        <div class="publish_main">
            <p>公司召开2018-2019年度战略合作签约发布会</p>
            <p class="con_p">2018年12月8日下午，司马大大（北京）智能系统有限公司“2018-2019年度战略合作签约发布会”在北京新世纪日航饭店举行。
                公司董事长陆军伍、首席科学家马兆远、副总裁郭洪涛、首席运营官谢建勋与来自全国的十五家合作伙伴出席了本次发布会，
                共同开启了司马大大2019年“合作共赢，科技见证”的全新征程。</p>
            <img src="../../../assets/images/10.png" alt="" class="pubimgs">
            <p class="bottom_p">董事长陆军伍</p>
            <p class="con_p">
                会议首先由董事长陆军伍先生向与会嘉宾介绍了视频行业的发展前景及本次合作的行业价值。
                同时，还强调了此次签约对于司马大大及签约伙伴未来发展的重要意义。
                2019年，作为全面开展战略合作的元年，司马大大将会为合作伙伴提供全方位、多角度的技术与业务支撑，构建优势互补的合作机制，
                为视频行业的发展提供可满足不同需求与应用场景的综合解决方案。
            </p>
            <img src="../../../assets/images/11.png" alt="" class="pubimgs">
            <p class="bottom_p">首席科学家马兆远教授</p>
            <p class="con_p">  随后，首席科学家马兆远教授就公司2019年的发展方向及公司即将推出的新产品进行了详尽介绍。
                基于已有技术积累与沉淀，司马大大未来将在视频数据结构化、视频数据压缩、视频数据溯源管理再度发力，并将深度挖掘行业需求，
                推出以“隐私保护”为核心的系列产品，助力合作伙伴业务拓展，全面推进行业应用。</p>
            <img src="../../../assets/images/12.png" alt="" class="pubimgs">
            <p class="bottom_p">市场销售副总裁郭洪涛</p>
            <p  class="con_p">最后，市场销售副总裁郭洪涛先生从业务合作的角度，向来宾介绍了公司在未来合作中的具体策略与落地方案。
                他提到，在产业升级的过程中，各大技术厂商非常需要“以点带面”来提升产品竞争优势的亮点技术。
                因此，司马大大将以开放的心态，加大对深耕行业应用的合作伙伴的支持力度，进行平台、产品层面技术的深度融合与对接。
                司马大大将始终专注于产品的“小而精”，定位于技术的“高精尖”，并以共赢的心态与合作伙伴携手一同为视频监控行业的智能升级，
                提供刚需型技术与服务支持。</p>
            <p class="con_p">
                本次签约发布会上，司马大大分别与十五家合作伙伴签署了战略合作协议，并授予合作伙伴牌照。此次发布会的与会公司分别为：
                北京德普视讯科技有限公司、北京富利德科技发展有限公司、北京汉安红腾科技有限公司、北京合力金智科技发展有限公司、北京华声世纪科技有限公司、
                北京明辰智航科技有限公司、北京鑫康泰科技有限公司、北京央迈科技有限公司、北京易拓软件有限公司、北京智瑞达信息技术发展有限公司、
                北京中数融合数据服务有限公司、北方延通（北京）能源科技有限公司、东方鼎泓（北京）智能技术有限公司、
                广东紫晶信息存储技术股份有限公司和济南芮熙电子有限公司。
            </p>
            <img src="../../../assets/images/13.png" alt="" class="pubimgs">
            <p class="bottom_p">司马大大与十五家合作伙伴</p>
        </div>
    </div>
</template>

<script>
import header from "../../cuscom/header";
export default {
    beforeRouteEnter: (to, from, next) => {
            next(vm => {
             window.scrollTo(0,0)
            });
        },
}
</script>

<style>
.news-banner {
     width: 100%;
 }
 .news-banner img {
     width: 100%;
     height: 100%;
 }

/* 面包屑 */
.nav_rot {
    width: 1200px;
    margin: 0 auto;
    font-size: 18px;
    margin-top: 35px;
}
.ivu-breadcrumb-item-link {
    color: #333333;
}


.publish_main {
    width: 1200px;
    margin: 0 auto;
    color: #333;
    margin-top: 94px;
    overflow: hidden;
    padding-bottom: 60px;
}
.publish_main p:nth-child(1) {
    font-size: 36px;
    /* font-weight: 700; */
    text-align: center;
    margin-bottom: 73px;
}
.publish_main .con_p {
    font-size: 14px;
    text-indent: 2em;
}
.publish_main .pubimgs{
    display: block;
    margin: 0 auto;
    margin-top: 25px;
    
}
.publish_main .bottom_p {
    font-size: 12px;
    color: #333;
    text-align: center;
    margin-bottom: 33px;
    margin-top: 8px;
}

</style>



// WEBPACK FOOTER //
// src/components/news/publish/publish.vue